import React from 'react';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';

import { DataBuilderFormContainer } from '../../../../ui/data-builder/data-builder-form-container/data-builder-form-container';
import { FreestyleContent } from '../../../../ui/data-builder/freestyle-content/freestyle-content';
import { useDriverBuilderContext } from '../../../contexts/driver-builder-context/driver-builder-context';

interface FreestyleDriverWizardScreenProps {
  onClose: () => void;
  onCreate: () => void;
  onUpdate: () => void;
}

export const FreestyleDriverWizardScreen = ({ onClose, onCreate, onUpdate }: FreestyleDriverWizardScreenProps) => {
  const { freestyleForm, sharedForm, view } = useDriverBuilderContext();
  const { errorCreatingDriver, errorUpdatingDriver, freestyleDriver, groups } = view.state;
  const {
    addToGroup,
    decimalDisplay,
    errors,
    handleAddToGroupChange,
    handleDecimalDisplayChange,
    handleInputMethodChange,
    handleNameChange,
    inputMethod,
    name,
    revalidate
  } = sharedForm;
  const { handleAddFinancialYear, handleChange, handleStoreOnTheChange, rows, storeOnThe, yearsAdded } = freestyleForm;

  return (
    <WizardScreen
      onCancel={onClose}
      onCreate={onCreate}
      onUpdate={onUpdate}
      footerMode={freestyleDriver ? FooterMode.UPDATE : FooterMode.CREATE}
    >
      <DataBuilderFormContainer
        addToGroup={addToGroup}
        decimalDisplay={decimalDisplay}
        errors={errors}
        groups={groups}
        inputMethod={inputMethod}
        isAddingNew={!freestyleDriver}
        isSaving={!!(errorCreatingDriver || errorUpdatingDriver)}
        name={name}
        onAddToGroupChange={handleAddToGroupChange}
        onDecimalDisplayChange={handleDecimalDisplayChange}
        onFieldBlur={revalidate}
        onInputMethodChange={handleInputMethodChange}
        onNameChange={handleNameChange}
        saveError={!!(errorCreatingDriver || errorUpdatingDriver)}
      >
        <FreestyleContent
          format="decimal"
          isAddingNew={!freestyleDriver}
          onAddFinancialYear={handleAddFinancialYear}
          onChange={handleChange}
          onStoreOnTheChange={handleStoreOnTheChange}
          rows={rows}
          storeOnThe={storeOnThe}
          yearsAdded={yearsAdded}
        />
      </DataBuilderFormContainer>
    </WizardScreen>
  );
};
